module.exports = __webpack_public_path__ + "img/bloom_taxonomy.60f26b29.jpg";